import { render, staticRenderFns } from "./smartText.vue?vue&type=template&id=21579d0a&scoped=true&"
import script from "./smartText.ts?vue&type=script&lang=js&"
export * from "./smartText.ts?vue&type=script&lang=js&"
import style0 from "./smartText.less?vue&type=style&index=0&id=21579d0a&lang=less&scoped=true&"
import style1 from "../comStyle/comStyle.less?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21579d0a",
  null
  
)

export default component.exports